import { Injectable } from '@angular/core';
import { AlertService, ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SearchableEntityConfig } from '../../models/searchable-entity-config';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { SearchableEntityServiceFactory } from '../../services/searchable-entity/searchable-entity-service-factory';
import { SimpleEntityActionService } from '../../services/searchable-entity/simple-entity/simple-entity-action.service';
import { SimpleEntityBackendService } from '../../services/searchable-entity/simple-entity/simple-entity-backend.service';
import { SimpleEntityDataEditorService } from '../../services/searchable-entity/simple-entity/simple-entity-data-editor.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { ImportLookupComponent } from '../import-lookup/import-lookup-popup.component';
import { ExcludeFromZonePopupButtonService } from './exclude-from-zone-popup-button.service';
import { ExcludeFromZonePopupDataService } from './exclude-from-zone-popup-data.service';

// [LFWM-2358 made exclude from zone a shared functionality and is used in both putwayzones and pickzones]
@Injectable()
export class ExcludeFromZonePopupHelperService {

    public serviceFactory: SearchableEntityServiceFactory;
    protected modalService: ModalService;
    public searchParams: SearchParams;
    protected dataService: ExcludeFromZonePopupDataService;
    protected actionService: SimpleEntityActionService;
    protected buttonService: ExcludeFromZonePopupButtonService;
    protected backendService: SimpleEntityBackendService;
    protected dataEditor: SimpleEntityDataEditorService;
    public buttonArray: any[] = [];
    
    constructor(protected coreServiceRegistry: CoreServiceRegistry,
        protected sharedServiceRegistry: SharedServiceRegistry, protected resourceService: ResourceService, 
        protected alertService: AlertService){
     
        this.dataService = new ExcludeFromZonePopupDataService(coreServiceRegistry, sharedServiceRegistry);
        this.actionService = new SimpleEntityActionService(coreServiceRegistry, sharedServiceRegistry);
        this.buttonService = new ExcludeFromZonePopupButtonService(coreServiceRegistry, sharedServiceRegistry);
        this.backendService = new SimpleEntityBackendService(coreServiceRegistry, sharedServiceRegistry);
        this.dataEditor = new SimpleEntityDataEditorService(coreServiceRegistry, sharedServiceRegistry);
        this.serviceFactory = new SearchableEntityServiceFactory(this.dataService, this.actionService,
            this.backendService, this.dataEditor, this.buttonService);
        this.modalService = sharedServiceRegistry.sceModalService;
        this.dataService.searchParams = new SearchParams();
        this.dataService.initializeEntityConfiguration(this.createEntityConfig());
    }

    protected createEntityConfig(): SearchableEntityConfig {
        const entityConfig = new SearchableEntityConfig('Exclude from Zone');
        return entityConfig;
    }

    public showPopup(defaultSearchCriteria, mandatoryProperties, tableId) {
        const lookupParams = new SearchParams();
        lookupParams.tableId = tableId;
        lookupParams.isFullFetch = false;
        lookupParams.tableEditor = this.dataEditor;
        this.dataService.searchParams = lookupParams;
        this.dataService.mandatoryProperties = mandatoryProperties;
        const lookupStatus = new SearchStatus();
        const tableConfig: DataTableConfig = new DataTableConfig();
        tableConfig.showIdAsAHyperLink = false;
        tableConfig.editable = true;
        tableConfig.supportFiltering = true;
        lookupParams.dataTableConfig = tableConfig;
        // LFWM-3191-fix to load buttons by privilege in popups.
        this.buttonArray = this.buttonService.getAllButtons();
        lookupParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.buttonArray['search-table']);
        this.dataService.searchService = this.sharedServiceRegistry.createSearchService(lookupParams, lookupStatus);
        this.dataService.searchService.setSearchCriteria(defaultSearchCriteria);
        this.alertService.clearAll();

        const modalRef: any = this.sharedServiceRegistry.sceModalService
            .showModal(ImportLookupComponent,
                { overlayHeader: this.resourceService.get('lbl_exclude_zn'),
                showHeader: true,
                overlayHeight: 520,
                overlayWidth: 1024
                });
        modalRef.content.initializeServices(this.serviceFactory);
        modalRef.content.showLookup = true;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/exclude-from-zone-popup/exclude-from-zone-popup-helper.service.ts